import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../../../../button/button';
import { IconPanel } from '../../../../icon-panel/icon-panel';
import { Stack } from '../../../../stack/stack';

type Props = { setIsEdited: (value: boolean) => void };

export const ToolStartedPanel = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Component>
      <IconPanel
        header={{ icon: { icon: ['fad', 'pen-ruler'], opacity: '50%', size: '8x' } }}
        responsiveness={{ compressed: false }}
      >
        {{
          title: t('initial.title', { ns: 'skyviewDesign' }) as string,
          info: (
            <Stack direction="column" spacing={0.5}>
              <span>
                <Trans
                  components={{ bold: <strong /> }}
                  i18nKey="initial.message"
                  ns="skyviewDesign"
                />
              </span>

              <Button color="primary" variant={'contained'} onClick={() => props.setIsEdited(true)}>
                {t('initial.newButton', { ns: 'skyviewDesign' })}
              </Button>
            </Stack>
          ),
        }}
      </IconPanel>
    </Component>
  );
};

const Component = styled.div`
  height: 100%;
  padding: 2em;
`;
